import React, { useRef, useEffect, useContext, useMemo } from "react";
import {
  VegaFlex,
  VegaFont,
  VegaIcon,
  VegaPopover,
} from "@heartlandone/vega-react";
import { waitForVega } from "@heartlandone/vega";
import { HubContext } from "Redux/Context/context";

function TeamRecruitment({ roles }) {
  const { dashboardBasicDataState } = useContext(HubContext);
  const { positionClassifications } = dashboardBasicDataState;
  const popoverRef = useRef(null);
  const compeleteRoles = (roles, roleNames) => {
    if (!roleNames) return [];
    return roles
      .map((role) => {
        const item = roleNames.find((item) => item.id === role.roleId);
        if (item) {
          return {
            roleName: item.name,
            numbers: role.numbers,
          };
        }
        return {}
      })
      .filter((role) => !!role);
  };
  const rolesCount = useMemo(
    () => compeleteRoles(roles, positionClassifications),
    [roles, positionClassifications]
  );

  useEffect(() => {
    waitForVega().then(() => {
      if (!popoverRef.current) return;
      const popover = popoverRef.current.shadowRoot.querySelector(
        "vega-popover-content-box"
      );
      const constentStyle = document.createElement("style");
      constentStyle.innerHTML = `:host .vega-popover-content{background-color: rgba(4, 4, 28, 1); border-color: rgba(4, 4, 28, 1); padding: 12px;}`;
      popover.shadowRoot.append(constentStyle);
      const arrowStyle = document.createElement("style");
      arrowStyle.innerHTML = `:host .vega-arrow::after{background-color: rgba(4, 4, 28, 1)!important; border-color: rgba(4, 4, 28, 1)!important;}`;
      popover.shadowRoot.append(arrowStyle);
    });
  }, [rolesCount]);

  return (
    rolesCount.length > 0 && (
      <VegaFlex gap="size-4">
        <VegaFont color="text-secondary" variant="font-field-label-sm">
          Team Recruitment
        </VegaFont>
        <VegaPopover ref={popoverRef} trigger='hover' placement='bottom'>
          <VegaIcon
            icon="fal fa-circle-question"
            slot="popover-content"
          ></VegaIcon>
          <VegaFlex slot="popover" direction="col">
            {rolesCount.map((role) => (
              <VegaFont
                variant="font-field-label-sm"
                color="text-inverted-primary"
                style={{padding: '0px 8px'}}
              >
                {`${role.numbers} ${role.roleName}`}
              </VegaFont>
            ))}
          </VegaFlex>
        </VegaPopover>
      </VegaFlex>
    )
  );
}

export default TeamRecruitment;
